<div class="container">
    <div class="errorContainer">
        <p class="title"> {{ 'endpoint_error404_title' | lbTranslateFromKey:{lang:locale.language} }} </p>
    </div>

    <div class="text" customMarkdown> {{ 'endpoint_error404_text' | lbTranslateFromKey:{lang:locale.language} }} </div>
    <img class="linebertyLogo" alt="lineberty logo" src="assets/img/lineberty_logo.svg" />
</div>
